export const LOADING_MY_SOLCITUD_CREDITO = 'LOADING_MY_SOLCITUD_CREDITO'
export const FETCH_MY_SOLCITUD_CREDITO_SUCCESS = 'FETCH_MY_SOLCITUD_CREDITO_SUCCESS'
export const FETCH_MY_SOLCITUD_CREDITO_ERROR = 'FETCH_MY_SOLCITUD_CREDITO_ERROR'
export const LOADING_SEND_SOLICITUD_CREDITO = 'LOADING_SEND_SOLICITUD_CREDITO'
export const GET_SEND_SOLICITUD_CREDITO_SUCCESS = 'GET_SEND_SOLICITUD_CREDITO_SUCCESS'
export const GET_SEND_SOLICITUD_CREDITO_ERROR = 'GET_SEND_SOLICITUD_CREDITO_ERROR'

export const FETCH_SOLICITUDES_HISTORY_REQUEST = 'FETCH_SOLICITUDES_HISTORY_REQUEST'
export const FETCH_SOLICITUDES_HISTORY_ERROR = 'FETCH_SOLICITUDES_HISTORY_ERROR'
export const FETCH_SOLICITUDES_HISTORY_SUCCESS = 'FETCH_SOLICITUDES_HISTORY_SUCCESS'

export const FETCH_MCR_DOCUMENTOS_REQUEST = 'FETCH_MCR_DOCUMENTOS_REQUEST'
export const FETCH_MCR_DOCUMENTOS_SUCCESS = 'FETCH_MCR_DOCUMENTOS_SUCCESS'

